import { useParams } from "react-router-dom";
import styles from "./ProductsSecondLevel.module.scss";
import { Category } from "../../components/products-page/components/products-categories/models/Category.model";
import { useEffect, useState } from "react";
import SecondLevelProductCard from "../../components/second-level-product-card/SecondLevelProductCard";
import ProductFiltersMenu from "../../components/product-filters-menu/ProductFiltersMenu";
import { getFixcenterCategories, getTranslateNameByProductUuid } from "../../services/products.service";
import { FixcenterFilterDto } from "../../components/product-filters-menu/models/fixcenter-filter-dto.model";
import { ProductFilter } from "../../components/product-filters-menu/models/product-filter.model";
import ProductsSkeletonGrid from "../../components/second-level-product-card/product-skeleton/product-skeleton";
import { Utils } from "../../shared/constants/utilities.constants";

export default function ProductsSecondLevel() {
    const { categoryId, directoryId, categoryName } = useParams();

    const [products, setProducts] = useState<Category[]>([]);
    const [searchByName, setSearchByName] = useState<string>("");
    const [isAnimationVisible, setIsAnimationVisible] = useState<boolean>(false);
    const [translateCategoryName, setTranslateCategoryName] = useState<string | null>(null);
    const [breadcrumbsTranslationCodes, setBreadcrumbsTranslationCodes] = useState<Record<string, string>>();
    const handleCategoryNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchByName(event.target.value);
    };

    const fetchCategories = async (fixcenterFilter: FixcenterFilterDto) => {
        try {
            if (categoryId) {
                setIsAnimationVisible(true);
                getFixcenterCategories(fixcenterFilter, directoryId).then((response: any) => {
                    if (response) {
                        const categoriesResponse = response.data as Category[];
                        setProducts(categoriesResponse);
                        setIsAnimationVisible(false);
                    }
                })
            }
        } catch (error) {
            console.error(error);
        }
    };

    const fetchTranslateNameByCategoryUuid = async () => {
        if (categoryId) {
            const languageCode = localStorage.getItem("lang");
            getTranslateNameByProductUuid(categoryId, languageCode).then((response: any) => {
                if (response) {
                    const translateName: string | null = response.data;
                    if (translateName && categoryName) {
                        setTranslateCategoryName(translateName);
                        setBreadcrumbsTranslationCodes(Utils.createRecord(categoryName, translateName));
                    }
                }
            })
        }
    }

    useEffect(() => {
        if (categoryId) {
            const languageCode = localStorage.getItem("lang");
            const productFilter: ProductFilter = {
                isCategory: true,
                parentProductId: categoryId,
            }
            const fixcenterFilter: FixcenterFilterDto = {
                productFilter: productFilter
            }
            if (languageCode) {
                fixcenterFilter.languageCode = languageCode;
            }
            fetchCategories(fixcenterFilter);
            fetchTranslateNameByCategoryUuid();
        }
    }, [categoryId]);


    return (
        <div className={styles.container}>
            <div className={styles.filters_menu}>
                <ProductFiltersMenu categoryName={categoryName} fetchCategories={fetchCategories} searchByName={handleCategoryNameChange} breadcrumbsTranslationCodes={breadcrumbsTranslationCodes} />
            </div>
            {isAnimationVisible ? 
                <section className={styles.content}>
                    <ProductsSkeletonGrid count={20}></ProductsSkeletonGrid>
                </section> : 
                <div className={styles.content}>
                    <div className={styles.category_header}>
                        {products.length > 0 ?
                            <p>{translateCategoryName && translateCategoryName.length > 0 ? translateCategoryName : categoryName}</p>
                            :
                            <p className={styles.notification}>Notification<br></br>
                                Filtering conditions matches 0 items</p>}
                    </div>
                    {categoryName &&
                        <div className={styles.cards_container}>
                            {products.map((product, index) => (
                                <div key={index} className={styles.single_product}>
                                    <SecondLevelProductCard categoryName={categoryName} product={product} />
                                </div>
                            ))}
                        </div>
                    }
                </div>    
            }
           
        </div>
    )
}